import React from 'react';
import HeroSaleTransactionModal from './HeroSaleTransactionModal';
import StopHeroSaleTransactionModal from './StopHeroSaleTransactionModal';
import TransactionSuccessModal from './TransactionSuccessModal';
import TransactionFailureModal from './TransactionFailureModal';
import { AppError } from 'src/redux/types';
import WalletConnectConfirmProvider from 'src/Components/WalletConnectConfirmProvider';
import { TestableProvider } from '@wolffun/testable-id';
var HeroSaleModalName;

(function (HeroSaleModalName) {
  HeroSaleModalName["SELLING_TRANSACTION"] = "selling_transaction";
  HeroSaleModalName["TRANSACTION_SUCCESS"] = "transaction_success";
  HeroSaleModalName["TRANSACTION_FAILURE"] = "transaction_failure";
  HeroSaleModalName["STOP_SELLING_TRANSACTION"] = "stop_selling_transaction";
})(HeroSaleModalName || (HeroSaleModalName = {}));

const noop = () => {};

const HeroSaleContext = /*#__PURE__*/React.createContext({
  sellHero: () => Promise.resolve(),
  stopSellingHero: () => Promise.resolve(),
  openModal: noop,
  closeModal: noop
});

const HeroSaleProvider = ({
  children
}) => {
  const [hero, setHero] = React.useState(null);
  const [modal, setModal] = React.useState(null);
  const [error, setError] = React.useState(AppError.NO_ERROR);
  const sellHero = React.useCallback(hero => {
    setHero(hero);
    setModal(HeroSaleModalName.SELLING_TRANSACTION);
  }, []);
  const stopSellingHero = React.useCallback(hero => {
    setHero(hero);
    setModal(HeroSaleModalName.STOP_SELLING_TRANSACTION);
  }, []);
  const openModal = React.useCallback(modal => {
    setModal(modal);
  }, []);
  const closeModal = React.useCallback(() => {
    setHero(null);
    setModal(null);
  }, []);
  const context = React.useMemo(() => {
    return {
      hero: hero || undefined,
      modal: modal || undefined,
      sellHero,
      openModal,
      closeModal,
      stopSellingHero
    };
  }, [hero, modal]);

  const renderModal = () => {
    switch (modal) {
      case HeroSaleModalName.SELLING_TRANSACTION:
        return hero ? /*#__PURE__*/React.createElement(HeroSaleTransactionModal, {
          hero: hero,
          onCompleted: () => openModal(HeroSaleModalName.TRANSACTION_SUCCESS),
          onFailure: error => {
            openModal(HeroSaleModalName.TRANSACTION_FAILURE);
            setError(error);
          },
          onClose: closeModal
        }) : null;

      case HeroSaleModalName.STOP_SELLING_TRANSACTION:
        return hero ? /*#__PURE__*/React.createElement(StopHeroSaleTransactionModal, {
          hero: hero,
          onCompleted: () => openModal(HeroSaleModalName.TRANSACTION_SUCCESS),
          onFailure: error => {
            openModal(HeroSaleModalName.TRANSACTION_FAILURE);
            setError(error);
          },
          onClose: closeModal
        }) : null;

      case HeroSaleModalName.TRANSACTION_SUCCESS:
        return /*#__PURE__*/React.createElement(TransactionSuccessModal, {
          onClose: () => {
            closeModal();
            location.reload();
          }
        });

      case HeroSaleModalName.TRANSACTION_FAILURE:
        return /*#__PURE__*/React.createElement(TransactionFailureModal, {
          error: error,
          onClose: closeModal
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/React.createElement(WalletConnectConfirmProvider, null, /*#__PURE__*/React.createElement(HeroSaleContext.Provider, {
    value: context
  }, children, /*#__PURE__*/React.createElement(TestableProvider, {
    testId: "sell"
  }, renderModal())));
};

export const useSellHero = () => {
  const {
    sellHero,
    stopSellingHero
  } = React.useContext(HeroSaleContext);
  return {
    sellHero,
    stopSellingHero
  };
};
export default HeroSaleProvider;